import { render } from "./ResourcePollingButton.vue?vue&type=template&id=956359d0"
import script from "./ResourcePollingButton.vue?vue&type=script&lang=js"
export * from "./ResourcePollingButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourcePollingButton.vue"]])

export default __exports__